<ig-row class="full-height">
    <ig-col [xs]="12" class="trip-side-bar">
        <ng-container>

            <div class="trip-category-wrap" #tripCategoryWrap>
                <div class="flex">
                    <span *ngIf="isEventEnabled&&!parent.isForTourList" class="event-icon" (click)="switchToEvents()"
                          [style.background]="style.tripPlanner.event.color.value"
                          matTooltipClass="category-tooltip-bg sidebar-main-icon event-color"
                          [matTooltip]="isMobile ? '' : 'Discover events and add stops to your custom trip'"
                          role="button" aria-label="go to events">
                        <mat-icon>date_range</mat-icon>
                        <span class="hide-on-mobile" [class.hidden]="!isShowingEventOrPlace">EVENTS</span>
                    </span>
                    <span *ngIf="isPlaceEnabled&&!parent.isForTourList" class="place-icon" (click)="switchToPlaces()"
                          [style.background]="style.tripPlanner.place.color.value"
                          matTooltipClass="category-tooltip-bg sidebar-main-icon place-color"
                          [matTooltip]="isMobile ? '' : 'Discover things to do and add stops to your custom trip'"
                          role="button"
                          aria-label="go to places">
                        <mat-icon>room</mat-icon>
                        <span class="hide-on-mobile" [class.hidden]="!isShowingEventOrPlace">PLACES</span>
                    </span>
                    <span *ngIf="!parent.isForTourList&&featuresToggle.itinerary" class="tour-icon"
                          (click)="switchToTours()" [style.background]="style.tripPlanner.tour.color.value"
                          matTooltipClass="category-tooltip-bg sidebar-main-icon tour-color"
                          [matTooltip]="isMobile ? '' : 'View our suggested itineraries'" role="button"
                          aria-label="go to itineraries">
                        <mat-icon>directions_car</mat-icon>
                        <span class="hide-on-mobile" [class.hidden]="!isShowingEventOrPlace">ITINERARIES</span>
                    </span>
                    <span *ngIf="!parent.isForTourList&&featuresToggle.tripPlanner" class="trip-icon"
                          (click)="switchToTrip()" [style.background]="style.tripPlanner.trip.color.value"
                          matTooltipClass="category-tooltip-bg sidebar-main-icon trip-color"
                          [matTooltip]="isMobile ? '' : 'View and edit your upcoming trips'" role="button"
                          aria-label="go to my trips">
                        <mat-icon>{{ isOpeningTrip ? 'more_horiz' : 'work' }}</mat-icon>
                        <span class="hide-on-mobile" [class.hidden]="!isShowingEventOrPlace">MY TRIPS</span>
                    </span>
                </div>

                <div *ngIf="!parent.isForSingleTour&&!parent.isForTourList" class="display-on"
                     [style.background]="displayingOnColor"
                     (click)="toggleFilter(displayingOn==='place'||displayingOn==='tour')"
                     [class.place-icon]="displayingOn==='place'" [class.tour-icon]="displayingOn==='tour'"
                     [class.trip-icon]="displayingOn==='trip'">
                    {{ listTitle }}
                    <span *ngIf="isMobile&&displayingOn==='event'">
                        {{ filterDateRangeText }}
                    </span>
                    <span *ngIf="displayingOn==='place'" class="toggle-tip">
                        <ng-container *ngIf="isShowFilter">
                            <mat-icon>expand_less</mat-icon>
                            hide
                        </ng-container>
                        <ng-container *ngIf="!isShowFilter">
                            <mat-icon>expand_more</mat-icon>
                            open
                        </ng-container>
                    </span>

                </div>

                <div
                    *ngIf="isMobile&&((displayingOn==='trip'&&trips.length)||(displayingOn==='tour'&&currentTour&&currentTour.attractions.length))">
                    <div *ngIf="!parent.isForSingleTour" class="back-to-tour-list" (click)="backToTourList()">BACK TO
                        ITINERARY LIST
                    </div>
                    <div *ngIf="displayingOn==='tour'" class="flex">
                        <div class="trip-show-map-top btn-border-right" (click)="showRouteOnMapForMobile()">
                            <mat-icon>map</mat-icon>
                            <span>show map</span>
                        </div>
                        <div class="trip-show-map-top btn-border-right">
                            <span *ngIf="!isDownloadingPDF" #menuTrigger="matMenuTrigger"
                                  [matMenuTriggerFor]="actionMenu" (click)="openPrintMenu()">
                                <mat-icon>picture_as_pdf</mat-icon>
                                <span>pdf</span>
                            </span>

                            <mat-spinner *ngIf="isDownloadingPDF" [diameter]="20" [strokeWidth]="3"></mat-spinner>
                            <mat-menu [yPosition]="'above'" #actionMenu="matMenu">
                                <button mat-menu-item
                                        (click)="displayingOn==='trip'?printTrip(false):printTour(false, $event)">
                                    <mat-icon>web</mat-icon>
                                    Online Version
                                </button>
                                <button mat-menu-item
                                        (click)="displayingOn==='trip'?printTrip(true):printTour(true, $event)">
                                    <mat-icon>chat</mat-icon>
                                    Print Version
                                </button>
                            </mat-menu>
                        </div>
                        <div class="trip-show-map-top" (click)="showShareTripModal('tour')">
                            <mat-icon>share</mat-icon>
                            <span>share</span>
                        </div>
                    </div>

                    <div *ngIf="displayingOn==='trip'" class="flex">
                        <ng-container *ngIf="displayingOn==='trip'&&!isEditTripMode&&!currentTrip&&trips&&trips.length">

                            <div class="trip-show-map-top btn-border-right"
                                 (click)="createNewTrip('New Trip', null, null, scrollToBottom)">
                                <mat-icon>add</mat-icon>
                                <span>Create Trip</span>
                            </div>
                            <div class="trip-show-map-top btn-border-right" (click)="openPrintMenu()">
                                <mat-spinner *ngIf="isDownloadingPDF" [diameter]="20" [strokeWidth]="3"></mat-spinner>
                                <span *ngIf="!isDownloadingPDF" #menuTrigger="matMenuTrigger"
                                      [matMenuTriggerFor]="actionMenu">
                                    <mat-icon>picture_as_pdf</mat-icon>
                                    <span>pdf</span>
                                </span>
                                <mat-menu share [yPosition]="'above'" #actionMenu="matMenu">
                                    <button mat-menu-item (click)="printTrip(false)">
                                        <mat-icon>web</mat-icon>
                                        Online Version
                                    </button>
                                    <button mat-menu-item (click)="printTrip(true)">
                                        <mat-icon>chat</mat-icon>
                                        Print Version
                                    </button>
                                </mat-menu>
                            </div>
                            <div class="trip-show-map-top" (click)="showShareTripModal('trip')">
                                <mat-icon>share</mat-icon>
                                <span>Share</span>
                            </div>

                        </ng-container>

                        <div *ngIf="displayingOn==='trip'&&currentTrip" class="flex">
                            <div class="trip-show-map-top btn-border-right" (click)="showRouteOnMapForMobile()">
                                <mat-icon>map</mat-icon>
                                <span>show map</span>
                            </div>

                            <div class="trip-show-map-top btn-border-right" (click)="openPrintMenu()">
                                <mat-spinner *ngIf="isDownloadingPDF" [diameter]="20" [strokeWidth]="3"></mat-spinner>
                                <span *ngIf="!isDownloadingPDF" #menuTrigger="matMenuTrigger"
                                      [matMenuTriggerFor]="actionMenu">
                                    <mat-icon>picture_as_pdf</mat-icon>
                                    <span>pdf</span>
                                </span>
                                <mat-menu share [yPosition]="'above'" #actionMenu="matMenu">
                                    <button mat-menu-item (click)="printTrip(false)">
                                        <mat-icon>web</mat-icon>
                                        Online Version
                                    </button>
                                    <button mat-menu-item (click)="printTrip(true)">
                                        <mat-icon>chat</mat-icon>
                                        Print Version
                                    </button>
                                </mat-menu>
                            </div>

                            <div class="trip-show-map-top" (click)="showShareTripModal('trip')">
                                <mat-icon>share</mat-icon>
                                <span>Share</span>
                            </div>

                        </div>


                    </div>
                </div>
            </div>
            <div #cardcontainer class="card-container"
                 [class.no-scroll]="displayingOn==='tour'&&!currentTour&&!isMobile"
                 [class.trip-card-container]="(displayingOn==='trip'&&!currentTrip&&isMobile)||(displayingOn==='tour'&&!currentTour&&isMobile)">


                <div class="filter-wrap" #filterEle [class.no-filter]="isMobile&&(displayingOn==='event'||isSearch)"
                     style="background-color: #eef5f9">
                    <ng-container *ngIf="displayingOn==='place'">


                        <div class="place-category-wrap">
                            <ig-custom-default-place-category-accordion [class.hide]="displayingOn!=='place'"
                                                                        *ngIf="customDefaultPlaceCategory&&!customDefaultPlaceCategory.useDefault"
                                                                        #customDefaultPlaceAccordion
                                                                        [toggleAndSource]="toggleAndSource"
                                                                        [menuType]="menuType"
                                                                        [menuMode]="'topbar'"
                                                                        (onCategoryClick)="selectCustomDefaultPlaceCategory($event)"
                                                                        (onNormalCategoryClick)="filterPlace($event)"
                                                                        [customDefaultPlaceCategory]="customDefaultPlaceCategory">
                            </ig-custom-default-place-category-accordion>

                            <div iconrow *ngIf="!isSearch" class="flex">
                                <!--                                don't use area business for trip planner-->

                                <ng-container *ngIf="customDefaultPlaceCategory.useDefault">
                                    <div icon #placeDining *ngIf="featuresToggle.placeCategory.dining"
                                         [matTooltip]="filter.place.dining.key"
                                         matTooltipClass="category-tooltip-bg dining-color"
                                         [class.dining]="filter.place.dining.value"
                                         [class.dining-hover]="!filter.place.dining.value&&!isMobile"
                                         (click)="filterCategory(filter.place.dining, true)" role="button"
                                         aria-label="go to dining">
                                        <mat-icon>restaurant</mat-icon>
                                    </div>

                                    <div icon #placeStay *ngIf="featuresToggle.placeCategory.accommodation"
                                         [matTooltip]="filter.place.accommodation.key"
                                         matTooltipClass="category-tooltip-bg accommodation-color"
                                         [class.accommodation]="filter.place.accommodation.value"
                                         [class.accommodation-hover]="!filter.place.accommodation.value&&!isMobile"
                                         (click)="filterCategory(filter.place.accommodation, true)" role="button"
                                         aria-label="go to accommodation">
                                        <mat-icon>hotel</mat-icon>
                                    </div>

                                    <div icon #placeShopping *ngIf="featuresToggle.placeCategory.shopping"
                                         [matTooltip]="filter.place.shopping.key"
                                         matTooltipClass="category-tooltip-bg shopping-color"
                                         [class.shopping]="filter.place.shopping.value"
                                         [class.shopping-hover]="!filter.place.shopping.value&&!isMobile"
                                         (click)="filterCategory(filter.place.shopping, true)" role="button"
                                         aria-label="go to shopping">
                                        <mat-icon>local_grocery_store</mat-icon>
                                    </div>

                                    <ng-container
                                        *ngIf="dataSource&&dataSource.place==='google'&&featuresToggle.placeCategory&&featuresToggle.placeCategory.thingsToDo">
                                        <div icon #placeActivity *ngIf="isShowThingsToDo"
                                             [matTooltip]="filter.place.thingsToDo.short"
                                             matTooltipClass="category-tooltip-bg activity-color"
                                             [class.activity]="filter.place.thingsToDo.value"
                                             [class.activity-hover]="!filter.place.thingsToDo.value&&!isMobile"
                                             (click)="filterCategory(filter.place.thingsToDo, true)" role="button"
                                             aria-label="go to things to do">
                                            <mat-icon>local_activity</mat-icon>
                                        </div>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="(dataSource&&dataSource.place==='facebook')||!featuresToggle.placeCategory||!featuresToggle.placeCategory.thingsToDo">
                                        <div icon #placeActivity *ngIf="featuresToggle.placeCategory.activity"
                                             [matTooltip]="filter.place.activity.key"
                                             matTooltipClass="category-tooltip-bg activity-color"
                                             [class.activity]="filter.place.activity.value"
                                             [class.activity-hover]="!filter.place.activity.value&&!isMobile"
                                             (click)="filterCategory(filter.place.activity, true)" role="button"
                                             aria-label="go to activity">
                                            <mat-icon>local_activity</mat-icon>
                                        </div>

                                        <div icon #arts *ngIf="featuresToggle.placeCategory.art"
                                             [matTooltip]="filter.place.art.key"
                                             matTooltipClass="category-tooltip-bg arts-color"
                                             [class.arts]="filter.place.art.value"
                                             [class.arts-hover]="!filter.place.art.value&&!isMobile"
                                             (click)="filterCategory(filter.place.art, true)" role="button"
                                             aria-label="go to art">
                                            <mat-icon>camera</mat-icon>
                                        </div>

                                        <div icon #placeOutdoor *ngIf="featuresToggle.placeCategory.outdoor"
                                             [matTooltip]="filter.place.outdoor.key"
                                             matTooltipClass="category-tooltip-bg outdoor-color"
                                             [class.outdoor]="filter.place.outdoor.value"
                                             [class.outdoor-hover]="!filter.place.outdoor.value&&!isMobile"
                                             (click)="filterCategory(filter.place.outdoor, true)" role="button"
                                             aria-label="go to outdoor">
                                            <mat-icon>terrain</mat-icon>
                                        </div>

                                        <div icon #placeWellness *ngIf="featuresToggle.placeCategory.wellness"
                                             [matTooltip]="filter.place.wellness.key"
                                             matTooltipClass="category-tooltip-bg wellness-color"
                                             [class.wellness]="filter.place.wellness.value"
                                             [class.wellness-hover]="!filter.place.wellness.value&&!isMobile"
                                             (click)="filterCategory(filter.place.wellness, true)" role="button"
                                             aria-label="go to wellness">
                                            <mat-icon>home</mat-icon>
                                        </div>

                                        <div icon #placeEntertainment *ngIf="featuresToggle.placeCategory.entertainment"
                                             [matTooltip]="filter.place.entertainment.key"
                                             matTooltipClass="category-tooltip-bg entertainment-color"
                                             [class.entertainment]="filter.place.entertainment.value"
                                             [class.entertainment-hover]="!filter.place.entertainment.value&&!isMobile"
                                             (click)="filterCategory(filter.place.entertainment, true)" role="button"
                                             aria-label="go to entertainment">
                                            <mat-icon>mood</mat-icon>
                                        </div>

                                    </ng-container>

                                    <div icon #placeTransportation *ngIf="featuresToggle.placeCategory.travel"
                                         [matTooltip]="filter.place.travel.short"
                                         matTooltipClass="category-tooltip-bg transportation-color"
                                         [class.transportation]="filter.place.travel.value"
                                         [class.transportation-hover]="!filter.place.travel.value&&!isMobile"
                                         (click)="filterCategory(filter.place.travel, true)" role="button"
                                         aria-label="go to travel">
                                        <mat-icon>flight_takeoff</mat-icon>
                                    </div>

                                    <div icon #placeOther *ngIf="featuresToggle.placeCategory.other"
                                         [matTooltip]="filter.place.other.key"
                                         matTooltipClass="category-tooltip-bg other-color"
                                         [class.other]="filter.place.other.value"
                                         [class.other-hover]="!filter.place.other.value&&!isMobile"
                                         (click)="filterCategory(filter.place.other, true)" role="button"
                                         aria-label="go to other">
                                        <mat-icon>public</mat-icon>
                                    </div>
                                </ng-container>

                                <!-- <ig-custom-default-place-category-accordion [class.hide]="displayingOn!=='place'"
                                    *ngIf="!customDefaultPlaceCategory.useDefault" #customDefaultPlaceAccordion
                                    [toggleAndSource]="toggleAndSource" [menuType]="menuType"
                                    [menuMode]="isMobile?'sidebar':'topbar'"
                                    (onCategoryClick)="selectCustomDefaultPlaceCategory($event)"
                                    (onNormalCategoryClick)="filterPlace($event)"
                                    [customDefaultPlaceCategory]="customDefaultPlaceCategory">
                                </ig-custom-default-place-category-accordion> -->

                                <!--                                <ng-container *ngIf="dataSource.isAreaBusiness">-->
                                <!--                                    <div icon #placeOther-->
                                <!--                                         [matTooltip]="filter.place.beauty.key"-->
                                <!--                                         matTooltipClass="category-tooltip-bg other-color"-->
                                <!--                                         [class.other]="filter.place.beauty.value"-->
                                <!--                                         [class.other-hover]="!filter.place.beauty.value&&!isMobile"-->
                                <!--                                         (click)="filterCategory(filter.place.beauty, true)" role="button"-->
                                <!--                                         aria-label="go to other">-->
                                <!--                                        <mat-icon>public</mat-icon>-->
                                <!--                                    </div>-->
                                <!--                                </ng-container>-->

                            </div>
                            <div iconrow *ngIf="isSearch"></div>
                        </div>
                    </ng-container>
                    <div class="flex full-width" style="background-color: #eef5f9"
                         [ngStyle]="{'justify-content':displayingOn==='event'?'space-between':'end'}">
                        <div>
                            <div *ngIf="showingCount" class="ig-trip-results map-view-list-info"
                                 [ngClass]="{'event-count':displayingOn==='event'}">
                                <div> {{ isSearch ? 'search' : '' }} results {{ showingCount }}</div>
                                <span *ngIf="!isPaginationInitStatus" [class.disabled]="noMoreBack"
                                      class="ig-trip-next small-btn btn-div" role="button" aria-label="go back"
                                      [style.background]="style.tripPlanner.buttons.color.value"
                                      (click)="pagingBack()">&lt;</span>
                                <span class="ig-trip-next btn-div" [class.disabled]="noMoreNext"
                                      [class.small-btn]="!isPaginationInitStatus" role="button" aria-label="go to next"
                                      [style.background]="style.tripPlanner.buttons.color.value"
                                      (click)="pagingNext()">{{ isPaginationInitStatus ? 'next page' : '>' }}</span>
                            </div>
                            <div *ngIf="!showingCount&&!isMobile" class="ig-trip-results map-view-list-info"
                                 [ngClass]="{'event-count':displayingOn==='event'}">
                                {{ isSearch ? 'search' : '' }} results {{
                                displayingOn === 'event' ? events.length
                                  ?
                                  '1 - ' + events.length : 0 : places.length ? '1 - ' + places.length : 0
                                }}
                            </div>
                        </div>

                        <div class="submit-btn btn-div" [style.background]="style.tripPlanner.buttons.color.value"
                             size="md" role="button" (click)="goToSubmitPage()">Submit your {{ displayingOn }}
                        </div>
                    </div>
                </div>

                <div class="card-wrap" #cardwrap [class.nopadding]="!isShowFilter"
                     [class.no-scroll]="displayingOn==='tour'&&!currentTour&&!isMobile"
                     [class.place-container]="displayingOn==='place'">
                    <ng-container *ngIf="displayingOn==='event'">
                        <!--<div *ngFor="let item of events; let i = index">-->
                        <!--<ig-visitor-trip-card [item]="item"-->
                        <!--[itemType]="'event'" (addTo)="addToTrip(i)"-->
                        <!--(removeFrom)="removeFromTrip(item._id)"-->
                        <!--(locateOnMap)="locateOnMap($event, i)"-->
                        <!--(showDetails)="showDetails(item, displayingOn, true, i)"-->
                        <!--&gt;</ig-visitor-trip-card>-->
                        <!--</div>-->

                        <div *ngFor="let row of eventRows; let i = index">
                            <div class="flex place-row">
                                <!--<ig-visitor-trip-place-card *ngFor="let item of row; let j = index"-->
                                <!--[item]="item"-->
                                <!--(locateOnMap)="locateOnMap($event, (i*cardCountInRow)+j)"-->
                                <!--(showDetails)="showDetails(item, displayingOn, true, (i*cardCountInRow)+j)"-->
                                <!--&gt;</ig-visitor-trip-place-card>-->
                                <ig-visitor-trip-card *ngFor="let item of row; let j = index" [item]="item"
                                                      [itemType]="'event'" [featuresToggle]="featuresToggle"
                                                      (removeFrom)="removeFromTrip(item._id)"
                                                      (locateOnMap)="locateOnMap($event, (i*cardCountInRow)+j)"
                                                      (showDetails)="showDetails(item, displayingOn, true, (i*cardCountInRow)+j)"></ig-visitor-trip-card>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="displayingOn==='place'">


                        <div *ngFor="let row of placeRows; let i = index">
                            <div class="flex place-row">
                                <ig-visitor-trip-place-card *ngFor="let item of row; let j = index" [item]="item"
                                                            [featuresToggle]="featuresToggle"
                                                            (locateOnMap)="locateOnMap($event, (i*cardCountInRow)+j)"
                                                            (showDetails)="showDetails(item, displayingOn, true, (i*cardCountInRow)+j)"></ig-visitor-trip-place-card>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="displayingOn==='tour'">
                        <img *ngIf="!currentTour&&!isMobile" [src]="tourSideImg" [alt]="'itinerary picture'"
                             width="100%">

                        <div *ngIf="currentTour&&!currentTour.attractions.length" class="no-item">
                            <div class="back-to-tour-list" (click)="backToTourList()">BACK TO ITINERARY LIST</div>
                            No Items in This Tour
                        </div>
                        <div *ngIf="(currentTour&&currentTour.attractions.length)">
                            <div class="tour-image">
                                <img [src]="imageService.safeImage(imageService.imageSourceUrl(currentTour.image))"
                                     width="100%" [alt]="'itinerary picture'">
                                <div trigger back style="display: none" *ngIf="isMobile&&currentTour"
                                     (click)="backToTourList()">&lt; Back to
                                    itinerary list
                                </div>
                                <div class="tour-title">
                                    <p *ngIf="currentTour.title" class="ellipsis" matTooltip="{{currentTour.title}}">
                                        {{ currentTour.title }}</p>
                                    <!--<p *ngIf="currentTour.description" matTooltip="{{currentTour.description}}">-->
                                    <!--{{currentTour.description.length>150?currentTour.description.substr(0,150)+'...':currentTour.description}}</p>-->
                                </div>
                            </div>
                            <ig-attraction-list #attractionlist type="tour" [isShareable]="false"
                                                [isShowAddtoMyTrip]="!parent.isForTourList&&featuresToggle.tripPlanner"
                                                [tour]="currentTour" (removeFromTrip)="removeFromTrip($event)"
                                                (onready)="mapReady()"
                                                (reordered)="reordered($event)"
                                                (showRouteOnMapMobile)="parent.showDirectionMap($event)"
                                                (onShowDetail)="hideMapMobileTrigger($event)"
                                                (onFloatDetailClose)="onCloseFloatDetail()" [isDisabled]="true"
                                                [isDraggable]="false"></ig-attraction-list>
                            <div #print class="export-wrap"
                                 *ngIf="!isMobile&&currentTour&&currentTour.attractions.length">

                                <ig-row>
                                    <ig-col [xs]="6">
                                        <ig-button *ngIf="!isDownloadingPDF" size="md" class="trip-show-map ig-blue-btn"
                                                   #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="actionMenu"
                                                   (trigger)="openPrintMenu()">
                                            <mat-icon>picture_as_pdf</mat-icon>
                                            Export as PDF
                                        </ig-button>
                                        <mat-spinner *ngIf="isDownloadingPDF" [diameter]="32"
                                                     [strokeWidth]="3"></mat-spinner>
                                        <mat-menu share [yPosition]="'above'" #actionMenu="matMenu">
                                            <button mat-menu-item (click)="printTour(false)">
                                                <mat-icon>web</mat-icon>
                                                Online Version
                                            </button>
                                            <button mat-menu-item (click)="printTour(true)">
                                                <mat-icon>chat</mat-icon>
                                                Print Version
                                            </button>
                                        </mat-menu>
                                    </ig-col>
                                    <ig-col [xs]="6">
                                        <ig-button size="md" class="trip-show-map ig-blue-btn"
                                                   (trigger)="showShareTripModal('tour')">
                                            <mat-icon>share</mat-icon>
                                            share itinerary
                                        </ig-button>
                                    </ig-col>
                                </ig-row>
                            </div>
                        </div>
                        <ng-container *ngIf="isMobile&&!currentTour">
                            <div *ngFor="let item of tours; let i = index" class="tour-card-mobile">
                                <ig-visitor-trip-card [item]="item" [itemType]="'tour'"
                                                      [titleBgColor]="style.tripPlanner.tour.color.value"
                                                      [featuresToggle]="featuresToggle"
                                                      (showDetails)="showTour(item, i)"></ig-visitor-trip-card>
                                <ig-spinner #tourspanner *ngIf="tourSpinner[i]"></ig-spinner>
                            </div>
                        </ng-container>

                    </ng-container>
                    <ng-container *ngIf="displayingOn==='trip'">

                        <!--<div class="share-trip-wrap"-->
                        <!--*ngIf="!isUserloggedIn&&((!currentTrip&&trips&&trips.length)||currentTrip&&currentTrip.attractions.length)">-->
                        <!--<div>Want to save your trips and access anywhere?</div>-->
                        <!--<ig-button *ngIf="!isUserLoggedIn" (trigger)="FBLogin()">-->
                        <!--<span style="margin-left: 0" *ngIf="!text" class="text-f-logo">f</span>-->
                        <!--<span style="margin-left: 8px">{{text||'Log in'}}</span>-->
                        <!--</ig-button>-->
                        <!--</div>-->

                        <div *ngFor="let trip of trips;let i = index" class="trip-card-wrap"
                             [class.trip-card-min-height]="!currentTrip">
                            <ng-container *ngIf="!currentTrip||(currentTrip&&i===currentTripIndex)">
                                <!--<img trip-->
                                <!--[src]="imageService.safeImage(imageService.imageSourceUrl(tripCoverImage(trip)))"-->
                                <!--alt="" (click)="enterTrip(i)">-->
                                <ig-image [imageUrl]="tripCoverImage(trip)" alt="trip picture"
                                          (click)="enterTrip(i)"></ig-image>
                                <div class="title-input-wrap" *ngIf="!isEditTripModes[i]"
                                     [style.background]="style.tripPlanner.buttons.color.value"
                                     [class.narrow-bottom]="!currentTrip&&i!==trips.length-1">
                                    <mat-icon *ngIf="!isSharedTrip&&currentTrip"
                                              (click)="!isSharedTrip&&enterTripOrEnterEditTitle(i)" role="button"
                                              aria-label="edit trip title">edit
                                    </mat-icon>
                                    <p title class="ellipsis" [style.background]="style.tripPlanner.buttons.color.value"
                                       matTooltip="{{trip.title}}">
                                        {{ trip.title }}</p>
                                    <div edit *ngIf="!isSharedTrip&&!currentTrip" (click)="enterTrip(i)" role="button"
                                         [style.background]="style.tripPlanner.trip.color.value"
                                         aria-label="enter trip">
                                        <div stops *ngIf="!currentTrip">{{ trip.attractions.length }}
                                            stop{{ trip.attractions.length > 1 ? 's' : '' }}
                                        </div>
                                        <div>EDIT MY TRIP</div>
                                    </div>
                                    <div delete *ngIf="!isSharedTrip&&currentTrip" (click)="deleteTrip(i, trip.id)"
                                         [style.background]="style.tripPlanner.buttons.color.value" role="button">
                                        DELETE TRIP
                                    </div>
                                </div>
                                <div *ngIf="isEditTripModes[i]" class="title-input-wrap"
                                     [class.narrow-bottom]="currentTrip||isEditTripModes[i]">
                                    <form ngForm="tripFormGroup">
                                        <ig-field #tripTitleInput class="ellipsis" [isSelectedOnInitial]="true"
                                                  [(ngModel)]="trip.title"
                                                  [formControl]="tripFormGroup.get('tripTitle')"
                                                  (onEnterKeyUp)="setTripTitle(trip.title, i)"></ig-field>
                                    </form>
                                    <mat-icon *ngIf="isEditTripModes[i]" matTooltip="save" class="trip-title-done"
                                              (click)="setTripTitle(trip.title, i)" role="button">done
                                    </mat-icon>
                                </div>
                            </ng-container>
                            <div style="height:8px;width:100%;" *ngIf="!currentTrip&&i<trips.length-1"></div>
                        </div>

                        <!--                        <div *ngIf="isMobile&&!currentTrip&&trips&&trips.length" class="mobile-separator"></div>-->

                        <ig-attraction-list *ngIf="currentTrip" #attractionlist type="trip" [isShareable]="true"
                                            [isDisabled]="isSharedTrip" [isShowAddtoMyTrip]="false" [tour]="currentTrip"
                                            (removeFromTrip)="removeFromTrip($event)" (onready)="mapReady()"
                                            (reordered)="reordered($event)"
                                            (onShowDetail)="hideMapMobileTrigger($event)"
                                            (onFloatDetailClose)="onCloseFloatDetail()"
                                            (showRouteOnMapMobile)="parent.showDirectionMap($event)"
                                            [isDraggable]="!isSharedTrip&&!parent.isPlanStarted"></ig-attraction-list>

                        <div class="no-item" *ngIf="currentTrip&&!currentTrip.attractions.length">
                            Oh no! You haven't added any events or places to visit to your trip yet. Go to <span
                            (click)="switchToEvents()">Events</span> or <span
                            (click)="switchToPlaces()">Places</span> and
                            start building your itinerary.
                        </div>
                    </ng-container>
                </div>
                <div *ngIf="isMobile&&!showingCount&&displayingOn==='place'&&!isNoItem&&!isNoTrip&&!isSwitching"
                     class="all-loaded">You loaded all available places in this area
                </div>

                <div class="no-item" *ngIf="isNoItem">
                    {{ isSwitching ? 'Loading...' : 'No Items' }}
                </div>
                <div class="no-item" *ngIf="isNoTrip">
                    Oh no! You haven't created your trip yet. Please <span (click)="showCreateTripModal(true)">create
                        your first trip</span>
                    and then
                    start building your itinerary.
                </div>

                <div *ngIf="isMobile" class="flex" style="justify-content: center;margin:40px 0 8px 0">
                    <ig-powered-by
                        [style]="'iti-horizontal'"></ig-powered-by>
                </div>

                <div class="mask" *ngIf="isSwitching" style="z-index: 999"></div>
                <ig-spinner class="spinner" *ngIf="isSwitching"></ig-spinner>
            </div>

            <ng-container *ngIf="!isMobile">
                <div *ngIf="displayingOn==='trip'&&!isEditTripMode&&!currentTrip&&trips&&trips.length"
                     class="ig-trip-results trip-bottom-row">

                    <span left create class="ig-trip-next" [style.background]="style.tripPlanner.trip.color.value"
                          (click)="createNewTrip('New Trip', null, null, scrollToBottom)" role="button">Create <span
                        new>new</span> trip</span>
                    <span middle class="ig-trip-next" (click)="showShareTripModal('trip')"
                          [style.background]="style.tripPlanner.buttons.color.value" role="button">Share trips</span>
                    <span right *ngIf="isDownloadingPDF"><mat-spinner [diameter]="32"
                                                                      [strokeWidth]="3"></mat-spinner></span>
                    <span right *ngIf="!isDownloadingPDF" class="ig-trip-next" #menuTrigger="matMenuTrigger"
                          [matMenuTriggerFor]="actionMenu" (click)="openPrintMenu()"
                          [style.background]="style.tripPlanner.buttons.color.value" role="button">Export as PDF</span>
                </div>

                <div *ngIf="displayingOn==='trip'&&currentTrip" class="ig-trip-results trip-bottom-row">
                    <span left create class="ig-trip-next" (click)="backToTripList()"
                          [style.background]="style.tripPlanner.trip.color.value">Back to All trips</span>
                    <span middle class="ig-trip-next" (click)="showShareTripModal('trip')"
                          [style.background]="style.tripPlanner.buttons.color.value">Share this trip</span>
                    <span right *ngIf="isDownloadingPDF"><mat-spinner [diameter]="32"
                                                                      [strokeWidth]="3"></mat-spinner></span>
                    <span right *ngIf="!isDownloadingPDF" class="ig-trip-next" #menuTrigger="matMenuTrigger"
                          [matMenuTriggerFor]="actionMenu" (click)="openPrintMenu()"
                          [style.background]="style.tripPlanner.buttons.color.value">Export as PDF</span>
                </div>

                <mat-menu share [yPosition]="'above'" #actionMenu="matMenu">
                    <button mat-menu-item (click)="printTrip(false)">
                        <mat-icon>web</mat-icon>
                        Online Version
                    </button>
                    <button mat-menu-item (click)="printTrip(true)">
                        <mat-icon>chat</mat-icon>
                        Print Version
                    </button>
                </mat-menu>
            </ng-container>
        </ng-container>
    </ig-col>
</ig-row>

<ig-trip-float-detail #details [showOperation]="isMobile"
                      [showAddToTrip]="!parent.isForTourList&&featuresToggle.tripPlanner"
                      [class.event-float-detail]="displayingOn==='event'" (onShown)="floatDetailShown($event)"
                      (onClosing)="floatDetailClosed($event)" (onPlaceFeedsClosing)="floatDetailFeedsClosed($event)"
                      (onPlaceFeedsRetrieved)="floatDetailPlaceFeedsRetrieved($event)"></ig-trip-float-detail>
<div placemask #placeMask></div>
<div class="category-mask" #placeCategoryMask (click)="closePlaceCategoryStartPage()">
</div>
<div #placeCategoryCloseIcon (click)="closePlaceCategoryStartPage()" class="place-category-start-page-close">
    <mat-icon>close</mat-icon>
</div>
<img #placeCategoryStartPage [src]="placeCategoryStartImg" alt="place category tip"
     class="place-category-start-page-img" style="opacity: 0!important;position: absolute;!important;z-index: -9999">

<div class="start-page-wrap" [class.start-page-wrap-multi-cities]="featuresToggle.multipleCities" #startPageIconWrap>
    <div class="flex">
        <div #placeDiningStartPageIcon class="place-category-start-page-icon start-page-dining"
             #placeCategoryStartPageTooltip="matTooltip" [matTooltip]="filter.place.dining.key"
             (mouseout)="placeCategoryStartPageTooltip.show()" (click)="filterCategory(filter.place.dining, true)"
             [class.dining]="filter.place.dining.value" matTooltipClass="category-tooltip-bg dining-color">
            <mat-icon>restaurant</mat-icon>
        </div>
        <div #placeStayStartPageIcon class="place-category-start-page-icon accommodation-hover"
             (mouseenter)="placeCategoryStartPageTooltip.hide()" [matTooltip]="filter.place.accommodation.key"
             (click)="filterCategory(filter.place.accommodation, true)"
             [class.accommodation]="filter.place.accommodation.value"
             matTooltipClass="category-tooltip-bg accommodation-color">
            <mat-icon>hotel</mat-icon>
        </div>

        <div class="place-category-start-page-icon arts-hover" (mouseenter)="placeCategoryStartPageTooltip.hide()"
             [matTooltip]="filter.place.art.key" (click)="filterCategory(filter.place.art, true)"
             [class.arts]="filter.place.art.value" matTooltipClass="category-tooltip-bg arts-color">
            <mat-icon>camera</mat-icon>
        </div>

        <div class="place-category-start-page-icon shopping-hover" [matTooltip]="filter.place.shopping.key"
             (mouseenter)="placeCategoryStartPageTooltip.hide()" (click)="filterCategory(filter.place.shopping, true)"
             [class.shopping]="filter.place.shopping.value" matTooltipClass="category-tooltip-bg shopping-color">
            <mat-icon>local_grocery_store</mat-icon>
        </div>
        <div class="place-category-start-page-icon activity-hover" [matTooltip]="filter.place.activity.key"
             (mouseenter)="placeCategoryStartPageTooltip.hide()" (click)="filterCategory(filter.place.activity, true)"
             [class.activity]="filter.place.activity.value" matTooltipClass="category-tooltip-bg activity-color">
            <mat-icon>local_activity</mat-icon>
        </div>
        <div class="place-category-start-page-icon outdoor-hover" [matTooltip]="filter.place.outdoor.key"
             (mouseenter)="placeCategoryStartPageTooltip.hide()" (click)="filterCategory(filter.place.outdoor, true)"
             [class.outdoor]="filter.place.outdoor.value" matTooltipClass="category-tooltip-bg outdoor-color">
            <mat-icon>terrain</mat-icon>
        </div>
        <div class="place-category-start-page-icon entertainment-hover" [matTooltip]="filter.place.entertainment.key"
             (mouseenter)="placeCategoryStartPageTooltip.hide()"
             (click)="filterCategory(filter.place.entertainment, true)"
             [class.entertainment]="filter.place.entertainment.value"
             matTooltipClass="category-tooltip-bg entertainment-color">
            <mat-icon>mood</mat-icon>
        </div>
        <div class="place-category-start-page-icon transportation-hover" [matTooltip]="filter.place.travel.short"
             (mouseenter)="placeCategoryStartPageTooltip.hide()" (click)="filterCategory(filter.place.travel, true)"
             [class.transportation]="filter.place.travel.value"
             matTooltipClass="category-tooltip-bg transportation-color">
            <mat-icon>flight_takeoff</mat-icon>
        </div>
        <div class="place-category-start-page-icon other-hover" [matTooltip]="filter.place.other.key"
             (mouseenter)="placeCategoryStartPageTooltip.hide()" (click)="filterCategory(filter.place.other, true)"
             [class.other]="filter.place.other.value" matTooltipClass="category-tooltip-bg other-color">
            <mat-icon>public</mat-icon>
        </div>
    </div>
</div>

<div #countbase *ngIf="currentTripsCount&&featuresToggle.tripPlanner&&!parent.isForTourList" class="trip-count"
     [class.trip-count-multi-cities]="featuresToggle.multipleCities"
     [class.trip-count-normal]="!featuresToggle.multipleCities">{{ currentTripsCount }}
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/trip/trip.side.bar/visitor.trip.side.bar.component.html